function CanonicalizeLocaleList(locales) {
  return Intl.getCanonicalLocales(locales);
}
export {
  CanonicalizeLocaleList
};
